(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('ProducerSummaryReportController', ProducerSummaryReportController);

	ProducerSummaryReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function ProducerSummaryReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			types: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		self.title = $state.current.data.title;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						var totalBottles = WineRepository.getTotalCellarBottleCount(wineEntities);

						var winesByProducer = lodash.groupBy(self.wines, function(w) {
							return (w.producer && w.producer.name) ? lodash.capitalize(w.producer.name.toLowerCase()) : 'Unknown';
						});

						self.report.tableHeaders = [
							'Producer (Total ' + Object.keys(winesByProducer).length + ')',
							'Wines',
							'% Wines in Cellar',
							'Bottles',
							'% Bottles in Cellar',
							'Vintages',
							'Categories',
							'In Stock Value',
							'Total Purchases',
							'Bottles out'
						];

						// initialize totals
						var totals = {
							wines:  0,
							bottles: 0,
							inStockValue: 0,
							purchaseValue: 0,
							bottlesOut: 0
						};

						lodash.forEach(winesByProducer, function(wines, producer) {
							var totalProducersWines = wines.length;

							// add wines to grand total
							totals.wines += totalProducersWines;

							// count bottles, start at 0
							var totalProducersBottles = lodash.reduce(wines, function(total, wine) {
								return total + lodash.parseInt(wine.cellar.qty);
							}, 0);
							// add bottles to grand total
							totals.bottles += totalProducersBottles;

							var vintages = lodash.unique(lodash.pluck(wines, 'vintage'));

							var categories = lodash.unique(lodash.pluck(wines, 'category.name'));

							var totalStockValue = lodash.sum(wines, function(wine) {
								// @todo use wine.cellar.totalValue when totalValue is fixed.
								// return wine.cellar.totalValue;
								return wine.cellar.value * lodash.parseInt(wine.cellar.qty);
							});
							// add to totals
							totals.inStockValue += totalStockValue;

							var totalPurchasesValue = lodash.sum(wines, function(wine) {
								var totalWineValue = 0;
								lodash.each(wine.cellar.history, function(history) {
									if (history.type === 'purchase') {
										totalWineValue += (history.price * lodash.parseInt(history.qty));
									}
								});
								return totalWineValue;
							});
							// add to totals
							totals.purchaseValue += totalPurchasesValue;

							// Assuming "Out" means all the below types.
							var totalBottlesOut = lodash.sum(wines, function(wine) {
								var totalOut = 0;

								var types = [
									'drink',
									'loss',
									'gift',
									'sale'
								];

								lodash.each(wine.cellar.history, function(history) {
									if (lodash.contains(types, history.type)) {
										totalOut += lodash.parseInt(history.qty);
									}
								});

								return totalOut;
							});
							// add to totals
							totals.bottlesOut += totalBottlesOut;

							var tableSummary = [
								// "Producer":
								(producer) ? producer : 'Unknown',
								// "Wines":
								totalProducersWines,
								// "% Wines in Cellar":
								$window.numeral(totalProducersWines / totalWines).format('0.00%'),
								// "Bottles":
								totalProducersBottles,
								// "% Bottles in Cellar":
								$window.numeral(totalProducersBottles / totalBottles).format('0.00%'),
								// "Vintages":
								vintages.length,
								// "Categories":
								categories.length,
								// "In Stock Value":
								$window.numeral(totalStockValue).format('$0.00'),
								// "Total Purchases":
								$window.numeral(totalPurchasesValue).format('$0.00'),
								// "Bottles out":
								totalBottlesOut
							];

							self.report.types.push({ summary: tableSummary });

						});

						self.report.totals = [
							// 'Producer (Total ' + Object.keys(winesByProducer).length + ')',
							'Totals',
							// 'Wines',
							totals.wines,
							// '% Wines in Cellar',
							null,
							// 'Bottles',
							totalBottles,
							// '% Bottles in Cellar',
							null,
							// 'Vintages',
							null,
							// 'Categories',
							null,
							// 'In Stock Value',
							$window.numeral(totals.inStockValue).format('$0,0.00'),
							// 'Total Purchases',
							$window.numeral(totals.purchaseValue).format('$0,0.00'),
							// 'Bottles out'
							totals.bottlesOut
						];

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function print(){
			return $window.print();
		}
	}

})();
